import LarsseitLight from './LarsseitLight.ttf';
import LarsseitRegular from './LarsseitRegular.ttf';
import LarsseitMedium from './LarsseitMedium.ttf';
import LarsseitBold from './LarsseitBold.ttf';
import AdvanceLineIcon from '../../icon/advance-line-icon/Advance-Line-Icon.ttf';
import AdvanceFeatureIcon from '../../icon/advance-feature-icon/Advance-Feature-Icon.ttf';
import AdvanceNavIcon from '../../icon/advance-nav-icon/Advance-Nav-Icon.ttf';
import AdvanceIcons from '../../icon/advance-design-system-icon/Advance-Design-System-Icon.ttf';
const fonts = {
  LarsseitLight,
  LarsseitRegular,
  LarsseitMedium,
  LarsseitBold,
  AdvanceLineIcon,
  AdvanceFeatureIcon,
  AdvanceNavIcon,
  AdvanceIcons
};
export default fonts;
//# sourceMappingURL=index.js.map